'use strict';

import { Component, OnInit, Input } from '@angular/core';
import * as moment from 'moment/moment';
import { HistorySearchResult } from '../../models/history-search-result';
import { MachineService } from '../../services/machine.service';
import { Machine } from '../../models/machine';
import { ToastsManager } from 'ng2-toastr';

@Component({
    selector: 'history-search',
    templateUrl: 'history-search.component.html',
    styleUrls: ['history-search.component.scss'],
    moduleId: module.id
})
export class HistorySearchComponent implements OnInit {

  @Input() machine: Machine;
  hasSearched: boolean = false;
  fromDate: Date = moment().startOf('day').toDate();
  toDate: Date = moment().endOf('day').toDate();
  datePickerSettings = {
    bigBanner: true,
    timePicker: true,
    format: 'yyyy-MM-dd hh:mm a Z',
    defaultOpen: false
  };
  searchResults: HistorySearchResult;
  page: number;
  searching: boolean = false;

  constructor(
      private machineService: MachineService,
      private toastr: ToastsManager) {
    this.page = 1;
  }

  ngOnInit(): void {}

  get hasHistory() {
    return this.searchResults && this.searchResults.rows.length;
  }

  async search() {
    let me = this;

    if (moment(this.fromDate).isAfter(moment(this.toDate))) {
      me.toastr.error('Start date must be before end date');
      return;
    }

    this.searching = true;
    this.hasSearched = true;
    this.machineService.getHistoryActivity(this.machine.id, this.fromDate, this.toDate, this.page, 'DESC')
      .then((searchResult: HistorySearchResult) => {
        me.searchResults = searchResult;
        me.searching = false;
        if (!me.page) {
          me.page = 1;
        } else if (me.page > me.searchResults.pages) {
          me.page = Math.max(me.searchResults.pages, 1);
        }

      })
      .catch((err: any) => {
        me.toastr.error(`An error occurred while searching.`);
        me.searching = false;
      })
  }

  goFirst() {
    this.page = 1;
    this.search();
  }

  goLast() {
    if (this.searchResults) {
      this.page = Math.max(this.searchResults.pages, 1);
      this.search();
    }
  }

  goNext() {
    if (this.searchResults && this.page < this.searchResults.pages) {
      this.page += 1;
      this.search();
    }
  }

  goPrev() {
    if (this.searchResults && this.page > 1) {
      this.page -= 1;
      this.search();
    }
  }

  goPage() {
    console.log('page is', this.page, 'and is of type', typeof(this.page));
    if (this.searchResults && this.page > 0 && this.page < this.searchResults.pages) {
      this.search();
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/components/history-search/history-search.component.ts